import React from 'react'
import { useFilterStore } from '../../state/filterStore'
import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import { FoodOption } from 'src/types/schema/graphql'
import { clearFilters, parseLabel } from '../../utils/functions'
import { Checkbox } from '@chakra-ui/react'

const FoodOptions: React.FC = () => {
    const {
        toggleFoodArrowUp,
        setToggleFoodArrowUp,
        foodFilterOptions,
        setFoodFilterOptions,
        showAllFilters,
        setShowAllFilters,
        setFilterCount,
    } = useFilterStore()

    const handleFilterSelection = (item: FoodOption) => {
        if (foodFilterOptions?.length) {
            if (!foodFilterOptions?.includes(item)) {
                setFoodFilterOptions([...foodFilterOptions, item])
            } else {
                setFoodFilterOptions(foodFilterOptions?.filter((brew) => brew !== item))
            }
        } else {
            setFoodFilterOptions([item])
        }
        setFilterCount()
    }

    const foodOptionChoices = Object.values(FoodOption).map((item) => ({
        label: parseLabel(item) === 'Any' ? 'Any Food Options' : parseLabel(item),
        value: item,
    }))

    return (
        <div
            className={classNames(
                'flex flex-col items-start justify-start',
                toggleFoodArrowUp ? 'mb-2' : ''
            )}
        >
            <UI.Button
                label='Food Options'
                data-cy='filterFood'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pb-0 pl-0'
                onClick={() => setToggleFoodArrowUp(!toggleFoodArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        toggleFoodArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>
            {foodFilterOptions.length && toggleFoodArrowUp ? (
                <div className='flex w-full flex-col'>
                    <UI.Button
                        theme='link'
                        customClasses='pl-0 text-sm flex items-center font-thin '
                        size='sm'
                        onClick={() => {
                            clearFilters('food')
                            setFoodFilterOptions([])
                            setFilterCount()
                        }}
                    >
                        <UI.Icon
                            slug='HeroIconsSolid.XCircle'
                            theme='link'
                            customClasses='mr-2'
                            size='sm'
                        />
                        Clear
                    </UI.Button>
                </div>
            ) : (
                ''
            )}

            <div
                className={classNames(
                    !toggleFoodArrowUp ? 'hidden' : '',
                    'flex flex-col overflow-hidden pl-1',
                    showAllFilters?.foodOptions || foodFilterOptions?.length > 0
                        ? 'h-auto'
                        : 'max-h-[7.5rem]'
                )}
            >
                {foodOptionChoices.map((item, index) => (
                    <div key={`filterOption-${item.label}`} className='flex flex-col'>
                        <Checkbox
                            className='food-filter pt-2'
                            id={`filterFood-${item?.value}-${index}`}
                            onChange={() => handleFilterSelection(item?.value)}
                            isChecked={item ? foodFilterOptions.includes(item.value) : false}
                            colorScheme='gray'
                        >
                            {item?.label}
                        </Checkbox>
                    </div>
                ))}
            </div>
            {toggleFoodArrowUp && (
                <div className='flex w-full flex-col'>
                    <UI.Button
                        theme='link'
                        customClasses='pl-1 text-sm flex items-center font-thin'
                        size='sm'
                        onClick={() =>
                            setShowAllFilters({
                                ...showAllFilters,
                                foodOptions: !showAllFilters.foodOptions,
                            })
                        }
                    >
                        {showAllFilters?.foodOptions || foodFilterOptions?.length > 0
                            ? 'Show Less'
                            : 'Show More'}
                        <UI.Icon
                            slug='HeroIconsSolid.ChevronDown'
                            theme='link'
                            customClasses={classNames(
                                'ml-2 ',
                                showAllFilters?.foodOptions || foodFilterOptions?.length > 0
                                    ? '-rotate-180'
                                    : ''
                            )}
                            size='sm'
                        />
                    </UI.Button>
                </div>
            )}
        </div>
    )
}

export default React.memo(FoodOptions)
